export function ConfirmSend(readings, isHeating) {
    return new Promise(function (resolve, reject) {
        // Создаем элементы с помощью нативных методов DOM
        var btnOk = document.createElement('button');
        btnOk.className = 'button-primary modal-1__button modal-1__submit modal-1__submit_mgt_lg';
        btnOk.textContent = 'Подтвердить';

        var btnCancel = document.createElement('button');
        btnCancel.className = 'button-secondary modal-1__submit';
        btnCancel.textContent = 'Скорректировать';

        var content = document.createElement('div');
        content.id = 'excess-consumption';
        content.className = 'modal-2 testimony-modal page__testimony-modal fancybox-content';
        content.style.display = 'inline-block';

        var sections = document.createElement('div');
        sections.className = 'modal-2__section';

        content.appendChild(sections);

        // Обработчики событий
        btnOk.addEventListener('click', function () {
            resolve(true);
            // Закрытие модального окна fancybox
            if (typeof $.fancybox !== 'undefined') {
                $.fancybox.close();
            }
        });

        btnCancel.addEventListener('click', function () {
            resolve(false);
            // Закрытие модального окна fancybox
            if (typeof $.fancybox !== 'undefined') {
                $.fancybox.close();
            }
        });

        // Создаем заголовок
        var title = document.createElement('h2');
        title.className = 'modal-2__title modal-2__title_accent';
        title.textContent = 'Подтвердите действие';
        sections.appendChild(title);

        // Создаем контент
        var body = document.createElement('div');
        body.className = 'modal-2__content';

        const txt = isHeating
            ? '<p>Заявленное вами показание</p>'
            : '<p>На заявленное вами показание начисление размера платы составляет</p>';
        body.innerHTML = txt;

        // Добавляем показания
        readings.forEach(function (item) {
            let itemData = isHeating
                ? (item.consumption + ' ' + item.unit)
                : (item.consumption + ' ' + item.unit + ', ' + item.cost + ' руб.');

            var p = document.createElement('p');
            var span = document.createElement('span');
            span.className = 'accent';
            span.textContent = itemData;
            p.appendChild(span);
            body.appendChild(p);
        });

        // Добавляем текст с подтверждением
        var confirmText = document.createElement('p');
        confirmText.textContent = 'Подтвердите передачу показаний или скорректируйте значение';
        body.appendChild(confirmText);

        sections.appendChild(body);
        sections.appendChild(btnOk);
        sections.appendChild(btnCancel);

        // Открываем модальное окно fancybox
        if (typeof $.fancybox !== 'undefined') {
            $.fancybox.open(content);
        } else {
            // Альтернативный способ открытия модального окна, если fancybox недоступен
            document.body.appendChild(content);
        }
    });
}
